var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 68,
    viewBox: "0 0 82 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5559 0H61.4985L81.9966 33.7604L61.4985 67.5208H21.1992L41.353 33.7604L21.5559 0ZM42.755 12.0529L55.8328 33.7604L42.755 55.4638H54.4718L67.4717 33.7604L54.3939 12.057H42.7181L42.755 12.0529Z",
    fill: "url(#paint0_linear_2159_2275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8071 15.1159L14.4881 33.761L25.7292 52.2544L18.5467 64.2581L0 33.761L18.7025 2.96875L25.8071 15.1159Z",
    fill: "url(#paint1_linear_2159_2275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2159_2275",
    x1: 51.5979,
    y1: 0,
    x2: 51.5979,
    y2: 67.5208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2159_2275",
    x1: 12.9036,
    y1: 2.96875,
    x2: 12.9036,
    y2: 64.2581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0D24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.31778bede77f6bd722553bd5fe93f374.svg";
export { ForwardRef as ReactComponent };